export default __webpack_public_path__ + "assets/clarens_midday_1k.3ed270157cdaa30feb404a8f4c281b2d.hdr";